(() => {
  const isLocalPreview = location.protocol === 'file:' || location.hostname === 'localhost';
  if (isLocalPreview) {
    document.querySelectorAll('[data-preview]').forEach((node) => {
      node.textContent = node.getAttribute('data-preview') || '';
    });
  }

  const pad2 = (n) => String(n).padStart(2, '0');
  const toKey = (date) => `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
  const addDays = (date, days) => {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
  };

  const easterDate = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const n = h + l - 7 * m + 114;
    const month = Math.floor(n / 31) - 1;
    const day = (n % 31) + 1;
    return new Date(year, month, day);
  };

  const holidaySet = (year) => {
    const fixed = [
      `${year}-01-01`,
      `${year}-05-01`,
      `${year}-05-08`,
      `${year}-07-14`,
      `${year}-08-15`,
      `${year}-11-01`,
      `${year}-11-11`,
      `${year}-12-25`,
    ];
    const easter = easterDate(year);
    const holidays = new Set(fixed);
    holidays.add(toKey(addDays(easter, 1)));
    holidays.add(toKey(addDays(easter, 39)));
    holidays.add(toKey(addDays(easter, 50)));
    return holidays;
  };

  const estimateShipping = (minBusinessDays, maxBusinessDays) => {
    const today = new Date();
    const holidays = new Set([
      ...holidaySet(today.getFullYear()),
      ...holidaySet(today.getFullYear() + 1),
    ]);

    let businessDays = 0;
    let minDate;
    let maxDate;

    for (let i = 1; i <= 60; i += 1) {
      const date = addDays(today, i);
      const weekday = date.getDay();
      if (weekday === 0 || weekday === 6) continue;
      if (holidays.has(toKey(date))) continue;

      businessDays += 1;
      if (businessDays === minBusinessDays && !minDate) minDate = date;
      if (businessDays === maxBusinessDays) {
        maxDate = date;
        break;
      }
    }

    if (!minDate || !maxDate) return null;

    return `${pad2(minDate.getDate())}/${pad2(minDate.getMonth() + 1)}–${pad2(
      maxDate.getDate(),
    )}/${pad2(maxDate.getMonth() + 1)}`;
  };

  const shippingDates = document.querySelector('[data-shipping-dates]');
  if (shippingDates) {
    const range = estimateShipping(4, 6);
    if (range) shippingDates.textContent = range;
  }

  const initGlobalPriceDisplayCleanup = () => {
    const PRICE_SCOPE_SELECTOR = [
      '.price',
      '.money',
      '.totals__total-value',
      '.cart-item__price-wrapper',
      '.lally-price',
      '.lby-pack-option__price',
      '.ecom-product-single__price-wrapper',
      '[data-price]',
      '[data-cart-total]',
    ].join(', ');

    const cleanupPriceText = (text) => {
      if (!text) return text;
      let next = text;
      // Format: 99,00 € / 99.00 EUR / 1 299,00€
      next = next.replace(/([0-9][0-9\s.,]*)([,.])00(?=\s*(€|\$|£|¥|₹|kr|USD|EUR|CHF|CAD|AUD|SEK|NOK|DKK|PLN|CZK|RON|R\$|₽|₩)\b)/gi, '$1');
      // Format: €99,00 / $99.00
      next = next.replace(/((€|\$|£|¥|₹)\s*[0-9][0-9\s.,]*)([,.])00\b/g, '$1');
      // Format: 99,00 (no explicit currency but in price blocks)
      next = next.replace(/([0-9][0-9\s.,]*)([,.])00\b/g, '$1');
      return next;
    };

    const cleanupNodeText = (node) => {
      if (!(node instanceof Node)) return;
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      let current = walker.nextNode();
      while (current) {
        const original = current.nodeValue || '';
        const cleaned = cleanupPriceText(original);
        if (cleaned !== original) current.nodeValue = cleaned;
        current = walker.nextNode();
      }
    };

    const cleanupPrices = (scope = document) => {
      const roots = [];
      if (scope instanceof Element && scope.matches(PRICE_SCOPE_SELECTOR)) roots.push(scope);
      if (scope.querySelectorAll) {
        scope.querySelectorAll(PRICE_SCOPE_SELECTOR).forEach((el) => roots.push(el));
      }
      roots.forEach(cleanupNodeText);
    };

    cleanupPrices(document);

    let rafId = 0;
    const pendingScopes = new Set();
    const schedule = (scope) => {
      pendingScopes.add(scope || document);
      if (rafId) return;
      rafId = window.requestAnimationFrame(() => {
        pendingScopes.forEach((pendingScope) => cleanupPrices(pendingScope));
        pendingScopes.clear();
        rafId = 0;
      });
    };

    const mo = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          const parent = mutation.target && mutation.target.parentElement;
          if (parent) schedule(parent);
          return;
        }
        mutation.addedNodes.forEach((added) => {
          if (!(added instanceof Element)) return;
          schedule(added);
        });
      });
    });

    mo.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  };

  const initHeaderCheckoutButton = (scope = document) => {
    const buttons =
      scope.querySelectorAll('[data-lby-header-checkout]').length > 0
        ? scope.querySelectorAll('[data-lby-header-checkout]')
        : document.querySelectorAll('[data-lby-header-checkout]');
    if (!buttons.length) return;

    buttons.forEach((button) => {
      if (button.dataset.checkoutInit === '1') return;
      button.dataset.checkoutInit = '1';

      button.addEventListener('click', async () => {
        const variantId = Number(button.getAttribute('data-variant-id') || '0');
        const quantity = Number(button.getAttribute('data-quantity') || '1');
        if (!variantId) {
          window.location.href = '/products/lallaby-one';
          return;
        }

        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = '...';
        try {
          const body = new URLSearchParams();
          body.set('id', String(variantId));
          body.set('quantity', String(quantity > 0 ? quantity : 1));

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body,
          });
          if (!response.ok) throw new Error('Checkout add failed');
          window.location.href = '/checkout';
        } catch (error) {
          window.location.href = `/cart/${variantId}:1?checkout`;
        } finally {
          button.disabled = false;
          button.textContent = originalText;
        }
      });
    });
  };

  /*
   * ===============================
   * Landing Page JS (lby-full-landing-page)
   * ===============================
   * Scope: only nodes with `.lp-hero[data-parallax-speed]` (legacy `.main-banner-wrapper` supported)
   */
  const landingParallaxCleanups = new Map();

  const initLandingParallax = (root) => {
    if (!root || root.dataset.parallaxInit === '1') return;

    const target = root.querySelector('.lp-hero__bg, .main-banner-container');
    if (!target) return;

    root.dataset.parallaxInit = '1';

    const speed = Number(root.dataset.parallaxSpeed || 0.2);
    const safeSpeed = Number.isFinite(speed) ? Math.max(0, speed) : 0.2;
    const parseDirection = (raw) => {
      const value = String(raw ?? '').trim().toLowerCase();
      if (value === '-1' || value === 'inverse' || value === 'reverse' || value === 'inversed') return -1;
      if (value === '1' || value === 'normal') return 1;
      const numeric = Number(value);
      if (Number.isFinite(numeric) && numeric !== 0) return numeric < 0 ? -1 : 1;
      return -1;
    };
    const safeDirection = parseDirection(root.dataset.parallaxDirection);
    const maxOffset = 48;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 768px)');
    let ticking = false;
    let inView = true;
    let rootTop = 0;
    let rootHeight = 0;
    let lastScrollY = window.scrollY;

    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
    const setOffset = (value) => {
      target.style.setProperty('--parallax-offset', `${value}px`);
    };
    const recalcMetrics = () => {
      const rect = root.getBoundingClientRect();
      rootTop = rect.top + window.scrollY;
      rootHeight = rect.height;
    };

    const update = () => {
      if (!inView) {
        ticking = false;
        return;
      }
      const mobileFactor = mobile.matches ? 0.35 : 1;
      const viewportCenter = window.innerHeight / 2;
      const sectionCenter = rootTop + rootHeight / 2 - window.scrollY;
      let delta = (viewportCenter - sectionCenter) * safeSpeed * safeDirection * mobileFactor;
      delta = clamp(delta, -maxOffset, maxOffset);
      setOffset(delta);
      ticking = false;
    };

    const requestUpdate = () => {
      if (reduced.matches) {
        setOffset(0);
        return;
      }
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };

    const onScroll = () => {
      if (!inView) return;
      const y = window.scrollY;
      if (Math.abs(y - lastScrollY) < 2) return;
      lastScrollY = y;
      requestUpdate();
    };
    const onResize = () => {
      recalcMetrics();
      requestUpdate();
    };

    recalcMetrics();
    requestUpdate();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    reduced.addEventListener('change', onResize);
    mobile.addEventListener('change', onResize);

    let observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries) => {
          inView = !!(entries[0] && entries[0].isIntersecting);
          if (inView) {
            recalcMetrics();
            requestUpdate();
          }
        },
        { root: null, rootMargin: '300px 0px 300px 0px', threshold: 0 },
      );
      observer.observe(root);
    }

    let resizeObserver = null;
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(() => {
        recalcMetrics();
        requestUpdate();
      });
      resizeObserver.observe(root);
    }

    const cleanup = () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      reduced.removeEventListener('change', onResize);
      mobile.removeEventListener('change', onResize);
      if (observer) observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      root.dataset.parallaxInit = '0';
      if (root.id) landingParallaxCleanups.delete(root.id);
    };

    if (root.id) landingParallaxCleanups.set(root.id, cleanup);
  };

  const initLandingParallaxIn = (scope = document) => {
    scope.querySelectorAll('.lp-hero[data-parallax-speed], .main-banner-wrapper[data-parallax-speed]').forEach((root) => {
      initLandingParallax(root);
    });
  };

  initLandingParallaxIn(document);
  initHeaderCheckoutButton(document);

  const initLandingHeroWordRotator = (scope = document) => {
    const wordNode = scope.querySelector('[data-lby-hero-word]') || document.querySelector('[data-lby-hero-word]');
    if (!wordNode || wordNode.dataset.rotatorInit === '1') return;
    wordNode.dataset.rotatorInit = '1';

    const words = [
      'fins du marché<sup style="font-size:0.3em; vertical-align:super;">1</sup>',
      'confortables',
      'discrets',
      'moelleux',
    ];
    let index = 0;
    const titleNode = wordNode.closest('h1.lp-hero__title, h1.main-banner-title') || wordNode.closest('.lp-hero__title, .main-banner-title');
    const textContainerNode = wordNode.closest('.lp-hero__content, .main-banner-text-container');

    const isMultiline = (node) => {
      if (!node) return false;
      const style = window.getComputedStyle(node);
      const lineHeight = Number.parseFloat(style.lineHeight);
      if (Number.isFinite(lineHeight) && lineHeight > 0) {
        return node.getBoundingClientRect().height > lineHeight * 1.35;
      }
      return node.getClientRects().length > 1;
    };

    const updateWrappedState = () => {
      const currentWord = wordNode.textContent.replace(/\s+/g, ' ').trim();
      const isMarketWord = currentWord.startsWith('fins du marché');
      const shouldWrapAdjust = isMarketWord && isMultiline(titleNode);
      wordNode.classList.toggle('is-wrapped', shouldWrapAdjust);
      if (titleNode) {
        titleNode.classList.toggle('has-wrapped-hero-word', shouldWrapAdjust);
      }
      if (textContainerNode) {
        textContainerNode.classList.toggle('has-wrapped-hero-word', shouldWrapAdjust);
      }
    };

    const setWord = () => {
      wordNode.innerHTML = words[index];
      window.requestAnimationFrame(updateWrappedState);
    };

    setWord();
    window.addEventListener('resize', updateWrappedState, { passive: true });
    window.setInterval(() => {
      wordNode.classList.add('is-changing');
      window.setTimeout(() => {
        index = (index + 1) % words.length;
        setWord();
        wordNode.classList.remove('is-changing');
      }, 180);
    }, 2000);
  };

  initLandingHeroWordRotator(document);

  const initLandingMobileSubtitleFocus = (scope = document) => {
    const container =
      scope.querySelector('[data-lby-mobile-subtitle]') || document.querySelector('[data-lby-mobile-subtitle]');
    if (!container || container.dataset.subtitleFocusInit === '1') return;

    const lines = Array.from(container.querySelectorAll('.lp-hero__mob-line, .main-banner-mobile-subtitle__line'));
    if (!lines.length) return;

    container.dataset.subtitleFocusInit = '1';
    const mobile = window.matchMedia('(max-width: 768px)');
    let ticking = false;
    let activeIndex = -1;

    const setActive = (nextIndex) => {
      if (nextIndex === activeIndex) return;
      activeIndex = nextIndex;
      lines.forEach((line, index) => {
        line.classList.toggle('is-active', index === nextIndex);
      });
    };

    const update = () => {
      ticking = false;
      if (!mobile.matches) {
        setActive(0);
        return;
      }

      const viewportCenterY = window.innerHeight / 2;
      let bestIndex = 0;
      let bestDistance = Number.POSITIVE_INFINITY;

      lines.forEach((line, index) => {
        const rect = line.getBoundingClientRect();
        const lineCenterY = rect.top + rect.height / 2;
        const distance = Math.abs(lineCenterY - viewportCenterY);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      setActive(bestIndex);
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    const onScroll = () => requestUpdate();
    const onResize = () => requestUpdate();
    const onMediaChange = () => requestUpdate();

    requestUpdate();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    mobile.addEventListener('change', onMediaChange);
  };

  initLandingMobileSubtitleFocus(document);

  const initLandingQuiz = (scope = document) => {
    const quiz =
      scope.querySelector('#lp-sleep-quiz') ||
      scope.querySelector('#lby-sleep-quiz') ||
      document.getElementById('lp-sleep-quiz') ||
      document.getElementById('lby-sleep-quiz');
    if (!quiz || quiz.dataset.quizInit === '1') return;
    quiz.dataset.quizInit = '1';

    const body = quiz.querySelector('[data-lp-quiz-body], [data-lby-quiz-body]');
    const progress = quiz.querySelector('[data-lp-quiz-progress], [data-lby-quiz-progress]');
    const backBtn = quiz.querySelector('[data-lp-quiz-back], [data-lby-quiz-back]');
    const openTriggers = document.querySelectorAll('[data-lp-quiz-open], [data-lby-quiz-open]');
    const closeTriggers = quiz.querySelectorAll('[data-lp-quiz-close], [data-lby-quiz-close]');
    if (!body || !progress || !backBtn) return;

    const questions = [
      {
        id: 'q1',
        title: 'Dans quelle position essayez-vous de vous endormir ?',
        options: [
          { value: 'A', label: "Sur le côté (l'oreille contre l'oreiller)." },
          { value: 'B', label: 'Sur le dos ou le ventre.' },
          { value: 'C', label: 'Je bouge dans tous les sens pour trouver ma place.' },
          { value: 'D', label: 'Je ne dors pas 🧛' },
        ],
      },
      {
        id: 'q2',
        title: 'Quel est votre principal ennemi au moment de dormir ?',
        options: [
          { value: 'A', label: "Mes propres pensées et le stress (mon cerveau ne s'arrête pas)." },
          { value: 'B', label: 'Les bruits extérieurs ou les ronflements de mon partenaire.' },
          { value: 'C', label: "Le silence total qui m'angoisse." },
          { value: 'D', label: 'La douleur aux oreilles causée par mes écouteurs actuels.' },
        ],
      },
      {
        id: 'q3',
        title: 'Avez-vous déjà essayé d’écouter du son (musique, podcast, ASMR) pour dormir ?',
        options: [
          { value: 'A', label: 'Oui, mais mes écouteurs me font mal ou tombent.' },
          { value: 'B', label: 'Oui, mais je dérange la personne à côté de moi.' },
          { value: 'C', label: "Non, je ne savais pas que c'était possible confortablement." },
          { value: 'D', label: "J'utilise des boules Quies, mais ça m'isole trop ou c'est inconfortable." },
        ],
      },
      {
        id: 'q4',
        title: 'Si vous aviez une baguette magique, que voudriez-vous ce soir ?',
        options: [
          { value: 'A', label: "M'endormir en moins de 20 minutes sans douleur." },
          { value: 'B', label: 'Créer une bulle pour ne plus entendre les ronflements.' },
          { value: 'C', label: 'Écouter mon histoire préférée sans gêne physique.' },
          { value: 'D', label: 'Juste arrêter de tourner dans le lit.' },
        ],
      },
    ];

    const results = {
      match: {
        title: 'Les Lallaby One sont faits pour vous à la perfection.',
        text: "Vous dormez sur le côté et cherchez du confort ? Vous êtes exactement le profil pour qui nous avons inventé Lallaby One. Fini la douleur du cartilage écrasé ou les écouteurs qui finissent dans les draps. C'est la solution sur-mesure que vos oreilles attendaient.",
        ctaLabel: 'Commander ma paire idéale',
        ctaHref: '/products/lallaby-one',
      },
      lifechanger: {
        title: 'Lallaby One peut vraiment changer vos nuits.',
        text: "Couper le flux de vos pensées ou masquer les bruits gênants est la clé pour vous endormir. Imaginez vous endormir apaisé chaque soir... Testez-les chez vous pendant 30 jours, sans risque : si vous ne dormez pas mieux, on vous rembourse.",
        ctaLabel: 'Démarrer mon essai de 30 nuits',
        ctaHref: '/products/lallaby-one',
      },
      reassuring: {
        title: "La seule chose que vous n'avez pas encore essayée.",
        text: "Vous avez probablement tout tenté. Le problème n'est pas vous, c'est l'inconfort des solutions actuelles. Lallaby One apporte une réponse ergonomique à un vrai problème physique. Donnez une dernière chance à votre sommeil, vos oreilles vous remercieront.",
        ctaLabel: 'Voir pourquoi ça marche',
        ctaHref: '/pages/pourquoi-nos-ecouteurs',
      },
    };

    let step = 0;
    let answers = {};
    let showingResult = false;

    const computeResult = () => {
      const q1 = answers.q1;
      const q2 = answers.q2;
      const q3 = answers.q3;
      if (q1 === 'A' && (q2 === 'D' || q3 === 'A' || q3 === 'D')) return results.match;
      if (q2 === 'A' || q2 === 'B') return results.lifechanger;
      return results.reassuring;
    };

    const renderQuestion = () => {
      const question = questions[step];
      showingResult = false;
      progress.textContent = `Question ${step + 1}/${questions.length}`;
      backBtn.hidden = step === 0;
      backBtn.textContent = '← Question précédente';
      body.innerHTML = `
        <h3 class="lp-quiz__question">${question.title}</h3>
        <div class="lp-quiz__options">
          ${question.options
            .map(
              (option) => `
                <button
                  type="button"
                  class="lp-quiz__option${answers[question.id] === option.value ? ' is-selected' : ''}"
                  data-lby-quiz-option="${option.value}"
                  aria-pressed="${answers[question.id] === option.value ? 'true' : 'false'}"
                >
                  <span class="lp-quiz__option-key">${option.value}.</span>
                  <span>${option.label}</span>
                </button>`,
            )
            .join('')}
        </div>
      `;
    };

    const renderResult = () => {
      const result = computeResult();
      showingResult = true;
      progress.textContent = 'Résultat';
      backBtn.hidden = false;
      backBtn.textContent = 'Modifier ma dernière réponse';
      body.innerHTML = `
        <div class="lp-quiz__result">
          <h3 class="lp-quiz__result-title">${result.title}</h3>
          <p class="lp-quiz__result-text">${result.text}</p>
          <a href="${result.ctaHref}" class="btn-full lp-quiz__result-cta">${result.ctaLabel}</a>
        </div>
      `;
    };

    const openQuiz = () => {
      step = 0;
      answers = {};
      quiz.classList.remove('is-closing');
      quiz.hidden = false;
      document.body.classList.add('lp-quiz-open');
      document.documentElement.classList.add('lp-quiz-open');
      window.requestAnimationFrame(() => {
        quiz.classList.add('is-open');
      });
      renderQuestion();
    };

    const closeQuiz = () => {
      if (quiz.hidden || quiz.classList.contains('is-closing')) return;
      quiz.classList.remove('is-open');
      quiz.classList.add('is-closing');
      window.setTimeout(() => {
        quiz.hidden = true;
        quiz.classList.remove('is-closing');
        document.body.classList.remove('lp-quiz-open');
        document.documentElement.classList.remove('lp-quiz-open');
      }, 320);
    };

    body.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-lby-quiz-option]');
      if (!btn) return;
      const question = questions[step];
      answers[question.id] = btn.getAttribute('data-lby-quiz-option');
      if (step < questions.length - 1) {
        step += 1;
        renderQuestion();
      } else {
        renderResult();
      }
    });

    backBtn.addEventListener('click', () => {
      if (showingResult) {
        step = questions.length - 1;
        renderQuestion();
        return;
      }
      if (step === 0) return;
      step -= 1;
      renderQuestion();
    });

    closeTriggers.forEach((node) => {
      node.addEventListener('click', closeQuiz);
    });

    openTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openQuiz();
      });
    });

    // Fallback robuste: ouvre le quiz même si le bouton est réinjecté après init.
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(
        '[data-lp-quiz-open], [data-lby-quiz-open], .lp-hero__quiz-btn[href="#lp-sleep-quiz"], .lp-hero__quiz-btn[href$="#lp-sleep-quiz"], .main-banner-quiz-btn[href="#lby-sleep-quiz"], .main-banner-quiz-btn[href$="#lby-sleep-quiz"]',
      );
      if (!trigger) return;
      event.preventDefault();
      openQuiz();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !quiz.hidden) closeQuiz();
    });
  };

  const initLandingCompactGallery = (scope = document) => {
    const roots = scope.matches && scope.matches('.lby-hero-compact')
      ? [scope]
      : Array.from(scope.querySelectorAll('.lby-hero-compact'));
    if (!roots.length) return;

    roots.forEach((root) => {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.compactGalleryInit === 'true') return;

      const thumbsRow = root.querySelector('.lby-gallery-thumbs--desktop');
      const imageThumbs = Array.from(root.querySelectorAll('.lby-gallery-thumbs--desktop [data-gallery-thumb--desktop]'));
      const mainImage = root.querySelector('.lby-gallery-main--desktop .lby-gallery-image');
      if (!thumbsRow || !mainImage || imageThumbs.length <= 0) return;

      let progress = root.querySelector('.lby-compact-gallery-progress');
      if (!progress) {
        progress = document.createElement('div');
        progress.className = 'lby-compact-gallery-progress';
        progress.setAttribute('aria-hidden', 'true');
        thumbsRow.insertAdjacentElement('afterend', progress);
      }

      const readThumbData = (thumb) => {
        const thumbImg = thumb.querySelector('img');
        return {
          src: thumb.getAttribute('data-src') || (thumbImg ? thumbImg.currentSrc || thumbImg.src : ''),
          alt: thumbImg ? thumbImg.alt : '',
        };
      };

      const slides = imageThumbs.map(readThumbData);
      const total = slides.length;
      if (total <= 1) return;

      progress.innerHTML = `
        <span class="lby-compact-gallery-bar lby-compact-gallery-bar--full">
          <span class="lby-compact-gallery-bar__fill"></span>
        </span>
      `;
      const barFill = progress.querySelector('.lby-compact-gallery-bar__fill');
      if (!barFill) return;

      const mod = (n, m) => ((n % m) + m) % m;

      let activeIndex = Math.max(
        0,
        imageThumbs.findIndex((thumb) => thumb.classList.contains('is-active'))
      );
      let hasStarted = false;
      let timer = null;

      const resetBar = () => {
        barFill.style.transition = 'none';
        barFill.style.transform = 'scaleX(0)';
      };

      const animateBar = () => {
        resetBar();
        void barFill.offsetWidth;
        window.requestAnimationFrame(() => {
          barFill.style.transition = 'transform 4s ease-in-out';
          barFill.style.transform = 'scaleX(1)';
        });
      };

      const setActive = (nextIndex) => {
        const previousIndex = activeIndex;
        activeIndex = mod(nextIndex, total);

        imageThumbs.forEach((thumb, idx) => {
          const isActiveThumb = idx === activeIndex;
          thumb.classList.toggle('is-active', isActiveThumb);
          thumb.setAttribute('aria-pressed', isActiveThumb ? 'true' : 'false');
        });

        const slide = slides[activeIndex];
        if (slide && slide.src) {
          mainImage.setAttribute('src', slide.src);
          mainImage.setAttribute('srcset', '');
          if (previousIndex !== activeIndex) {
            if (mainImage._softSlideResetTimer) {
              window.clearTimeout(mainImage._softSlideResetTimer);
            }
            mainImage.style.transition = 'none';
            mainImage.style.transform = 'translate3d(4%, 0, 0)';
            mainImage.style.opacity = '0.995';
            // Double RAF to ensure browser commits the initial state before transition.
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                mainImage.style.transition = 'transform 320ms cubic-bezier(0.22, 0.61, 0.36, 1), opacity 320ms ease';
                mainImage.style.transform = 'translate3d(0, 0, 0)';
                mainImage.style.opacity = '1';
              });
            });
            mainImage._softSlideResetTimer = window.setTimeout(() => {
              mainImage.style.transition = '';
            }, 340);
          }
        }
        if (slide && slide.alt) {
          mainImage.setAttribute('alt', slide.alt);
        }

        const activeThumb = imageThumbs[activeIndex];
        if (activeThumb) {
          const targetLeft = activeThumb.offsetLeft - (thumbsRow.clientWidth - activeThumb.clientWidth) / 2;
          thumbsRow.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
        }

      };

      const clearTimers = () => {
        if (timer) {
          window.clearTimeout(timer);
          timer = null;
        }
      };

      const runCycle = () => {
        if (!hasStarted) return;
        animateBar();
        timer = window.setTimeout(() => {
          setActive(activeIndex + 1);
          runCycle();
        }, 4000);
      };

      const restartCycle = () => {
        clearTimers();
        if (!hasStarted) return;
        runCycle();
      };

      imageThumbs.forEach((thumb, idx) => {
        thumb.addEventListener('click', () => {
          if (!hasStarted) hasStarted = true;
          setActive(idx);
          restartCycle();
        });
        thumb.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (!hasStarted) hasStarted = true;
          setActive(idx);
          restartCycle();
        });
      });

      setActive(activeIndex);
      resetBar();

      const startIfNeeded = () => {
        if (hasStarted) return;
        const rect = root.getBoundingClientRect();
        const viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
        const visiblePx = Math.min(rect.bottom, viewportH) - Math.max(rect.top, 0);
        if (visiblePx > 0) {
          hasStarted = true;
          restartCycle();
        }
      };

      const io = new IntersectionObserver(
        (entries) => {
          const visible = entries.some((entry) => entry.isIntersecting);
          if (visible && !hasStarted) {
            hasStarted = true;
            restartCycle();
          }
          if (!visible) clearTimers();
          if (visible && hasStarted && !timer) restartCycle();
        },
        { threshold: 0, rootMargin: '0px' },
      );
      io.observe(root);
      startIfNeeded();

      root.dataset.compactGalleryInit = 'true';
      root._compactGalleryObserver = io;
    });
  };

  initLandingQuiz(document);
  initLandingCompactGallery(document);
  initGlobalPriceDisplayCleanup();

  document.addEventListener('shopify:section:load', (event) => {
    const scope = event?.target instanceof HTMLElement ? event.target : document;
    initLandingParallaxIn(scope);
    initLandingHeroWordRotator(scope);
    initLandingMobileSubtitleFocus(scope);
    initLandingQuiz(scope);
    initLandingCompactGallery(scope);
    initHeaderCheckoutButton(scope);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionId = event?.detail?.sectionId;
    if (!sectionId) return;
    const cleanup =
      landingParallaxCleanups.get(`lp-hero-${sectionId}`) ||
      landingParallaxCleanups.get(`main-banner-${sectionId}`);
    if (cleanup) cleanup();
  });

  /*
   * ===============================
   * Product Page JS (lby-full-product-page)
   * ===============================
   * Scope: only pages containing `[data-pack-selector]`
   */
  initStickyATC();

  const packSelector = document.querySelector('[data-pack-selector]');
  if (!packSelector) return;

  const priceBefore = document.querySelector('.lally-price__before');
  const priceInteger = document.querySelector('.lally-price__integer');
  const priceCurrency = document.querySelector('.lally-price__decimals .currency');
  const quantityInput = document.getElementById('Quantity');

  // Prices are rendered with Liquid; JS only handles selection/quantity.

  const galleryMain = document.querySelector('[data-gallery-main]');
  const galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
  const galleryItems = document.querySelectorAll('[data-gallery-item]');
  const updateGalleryState = (mediaId, mediaType) => {
    galleryItems.forEach((item) => {
      item.classList.toggle('is-active', item.getAttribute('data-media-id') === mediaId);
      const video = item.querySelector('video');
      const playBtn = item.querySelector('.lby-video-play');
      if (video && item.getAttribute('data-media-id') !== mediaId) {
        video.pause();
        if (playBtn) playBtn.classList.remove('is-playing');
      }
    });
    if (galleryMain) {
      galleryMain.classList.toggle('is-video', mediaType === 'video');
    }
  };

  if (galleryMain && galleryThumbs.length) {
    const activateThumb = (thumb) => {
      const mediaId = thumb.getAttribute('data-media-id');
      const mediaType = thumb.getAttribute('data-media-type') === 'video' ? 'video' : 'image';
      if (!mediaId) return;

      galleryThumbs.forEach((btn) => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');

      updateGalleryState(mediaId, mediaType);
    };

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => activateThumb(thumb));
      thumb.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activateThumb(thumb);
        }
      });
    });

    const activeThumb = document.querySelector('[data-gallery-thumb].is-active');
    if (activeThumb) {
      updateGalleryState(
        activeThumb.getAttribute('data-media-id'),
        activeThumb.getAttribute('data-media-type') === 'video' ? 'video' : 'image',
      );
    }
  }

  document.querySelectorAll('.lby-video-play').forEach((btn) => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.lby-gallery-item--video');
      const video = wrapper ? wrapper.querySelector('video') : null;
      if (!video) return;
      if (video.paused) {
        video.play();
        btn.classList.add('is-playing');
      } else {
        video.pause();
        btn.classList.remove('is-playing');
      }
    });
  });

  document.querySelectorAll('.lby-gallery-thumb--video').forEach((thumb) => {
    const video = thumb.querySelector('video');
    if (!video) return;

    const toggleVideo = () => {
      document.querySelectorAll('.lby-gallery-thumb--video.is-playing').forEach((other) => {
        if (other === thumb) return;
        other.classList.remove('is-playing');
        other.classList.add('is-started');
        const otherVideo = other.querySelector('video');
        if (otherVideo) otherVideo.pause();
      });

      if (video.paused) {
        video.play();
        thumb.classList.add('is-playing');
        thumb.classList.add('is-started');
      } else {
        video.pause();
        thumb.classList.remove('is-playing');
        thumb.classList.add('is-started');
      }
    };

    thumb.addEventListener('click', (event) => {
      if (event.target.closest('button') || event.target.closest('img') || event.target.closest('video')) {
        toggleVideo();
        return;
      }
      toggleVideo();
    });
  });

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (canHover) {
    document.querySelectorAll('.lby-gallery-thumb').forEach((thumb) => {
      if (thumb.classList.contains('lby-gallery-thumb--video')) return;
      if (thumb.closest('.lby-hero-compact')) return;
      const img = thumb.querySelector('img');
      if (!img) return;

      thumb.addEventListener('mousemove', (event) => {
        const rect = thumb.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
        thumb.classList.add('is-zooming');
        thumb.classList.remove('is-origin-return');
      });

      thumb.addEventListener('mouseleave', () => {
        thumb.classList.remove('is-zooming');
        thumb.classList.add('is-origin-return');
        img.style.transformOrigin = '50% 50%';
        window.clearTimeout(thumb._originReturnTimer);
        thumb._originReturnTimer = window.setTimeout(() => {
          thumb.classList.remove('is-origin-return');
        }, 360);
      });
    });
  }

  const initPeekSlider = (root) => {
    const viewport = root.querySelector('[data-viewport]');
    const slides = Array.from(root.querySelectorAll('.lby-peek-slider__slide'));
    const videos = Array.from(root.querySelectorAll('.lby-peek-slider__video'));
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    if (!viewport || slides.length === 0) return;

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
    let active = 0;
    let dragSession = false;
    let dragStartScroll = 0;
    let dragStartIndex = 0;

    const setActive = (i) => {
      active = clamp(i, 0, slides.length - 1);
      dots.forEach((dot, ix) => {
        const on = ix === active;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    };

    const goTo = (i) => {
      const ix = clamp(i, 0, slides.length - 1);
      const left = slides[ix].offsetLeft;
      viewport.scrollTo({ left, behavior: 'smooth' });
      setActive(ix);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(Number(dot.getAttribute('data-index') || 0));
      });
    });

    const setPlaying = (video, on) => {
      const slide = video.closest('.lby-peek-slider__slide');
      if (slide) slide.classList.toggle('is-playing', on);
    };

    const setPlayed = (video) => {
      const slide = video.closest('.lby-peek-slider__slide');
      if (slide) slide.classList.add('is-played');
    };

    const pauseOthers = (except) => {
      videos.forEach((video) => {
        if (video !== except) {
          video.pause();
          setPlaying(video, false);
        }
      });
    };

    root.querySelectorAll('.lby-peek-slider__play').forEach((btn) => {
      btn.addEventListener('click', () => {
        const slide = btn.closest('.lby-peek-slider__slide');
        const video = slide ? slide.querySelector('video') : null;
        if (!video) return;
        pauseOthers(video);
        video.muted = false;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
        setPlayed(video);
        setPlaying(video, true);
      });
    });

    videos.forEach((video) => {
      video.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (video.paused) {
          pauseOthers(video);
          video.muted = false;
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
          setPlayed(video);
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', () => setPlaying(video, true));
      video.addEventListener('pause', () => setPlaying(video, false));
      video.addEventListener('ended', () => setPlaying(video, false));
    });

    const nearestIndex = () => {
      const x = viewport.scrollLeft + 1;
      let nearest = 0;
      let best = Infinity;
      for (let i = 0; i < slides.length; i += 1) {
        const dist = Math.abs(slides[i].offsetLeft - x);
        if (dist < best) {
          best = dist;
          nearest = i;
        }
      }
      return nearest;
    };

    const stepSize = () => {
      const gap = parseFloat(getComputedStyle(root).getPropertyValue('--gap')) || 0;
      const w = slides[0] ? slides[0].offsetWidth : 0;
      return w + gap;
    };

    const onDragStart = () => {
      dragSession = true;
      dragStartScroll = viewport.scrollLeft;
      dragStartIndex = active;
    };

    const onDragEnd = () => {
      if (!dragSession) return;
      const dragDelta = viewport.scrollLeft - dragStartScroll;
      const step = stepSize();
      if (Math.abs(dragDelta) > 0 && step > 0) {
        if (Math.abs(dragDelta) < step * 0.5) {
          goTo(dragStartIndex + (dragDelta > 0 ? 1 : -1));
        } else {
          goTo(nearestIndex());
        }
      } else {
        goTo(active);
      }
      dragSession = false;
    };

    viewport.addEventListener('pointerdown', onDragStart, { passive: true });
    viewport.addEventListener('pointerup', onDragEnd, { passive: true });
    viewport.addEventListener('pointercancel', onDragEnd, { passive: true });
    viewport.addEventListener('touchstart', onDragStart, { passive: true });
    viewport.addEventListener('touchend', onDragEnd, { passive: true });

    let ticking = false;
    viewport.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          setActive(nearestIndex());
          ticking = false;
        });
      },
      { passive: true },
    );

    window.addEventListener('resize', () => goTo(active), { passive: true });

    const initial = Math.max(dots.findIndex((dot) => dot.classList.contains('is-active')), 0);
    setActive(initial);
    if (slides[initial]) {
      viewport.scrollLeft = slides[initial].offsetLeft;
    }
  };

  document.querySelectorAll('[data-lby-peek-slider]').forEach(initPeekSlider);

  const initFooterMask = () => {
    if (!document.body.classList.contains('template-product') || !document.querySelector('.lby-product')) return;
    const footer = document.querySelector('footer');
    if (!footer) return;

    let mask = document.getElementById('lby-footer-mask');
    if (!mask) {
      mask = document.createElement('div');
      mask.id = 'lby-footer-mask';
      document.body.appendChild(mask);
    }

    const toggleMask = () => {
      const docHeight = document.documentElement.scrollHeight;
      const maxScroll = Math.max(docHeight - window.innerHeight, 1);
      const progress = window.scrollY / maxScroll;
      const hideFooter = progress < 0.8;
      document.body.classList.toggle('lby-footer-masked', hideFooter);
    };

    toggleMask();
    window.addEventListener('scroll', toggleMask, { passive: true });
    window.addEventListener('resize', toggleMask, { passive: true });
  };

  initFooterMask();

  function initStickyATC() {
    let bar = document.querySelector('[data-lby-sticky-atc]');
    if (!bar) return;

    const formId = bar.getAttribute('data-form-id');
    const form = document.getElementById(formId);
    const stickyBtn = bar.querySelector('[data-lby-sticky-atc-btn]');
    const stickyLabel = bar.querySelector('[data-lby-sticky-atc-label]');

    if (!form || !stickyBtn) return;

    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    const findMainButton = () => form.querySelector('button[name="add"], button[type="submit"]');

    const findObserveTarget = () => {
      // Landing: show sticky only after passing the compact product sheet block.
      const landingProductSection = document.querySelector('.lby-hero-compact');
      if (landingProductSection) return landingProductSection;
      return form;
    };

    const syncState = () => {
      const mainBtn = findMainButton();
      if (!mainBtn) return;

      stickyBtn.disabled = !!mainBtn.disabled;
      stickyBtn.setAttribute('aria-disabled', mainBtn.disabled ? 'true' : 'false');

      const txt =
        (mainBtn.querySelector('span') && mainBtn.querySelector('span').textContent) ||
        mainBtn.textContent ||
        '';
      const clean = (txt || '').replace(/\s+/g, ' ').trim();
      if (stickyLabel && clean) stickyLabel.textContent = clean;
    };

    const isDrawerOpen = () => {
      const bodyClass = document.body.className || '';
      if (/cart-drawer-open|drawer-open|aov-cart-open|aov-drawer-open|cart-open/i.test(bodyClass)) {
        return true;
      }

      const selectors = [
        '.AOV-CartDrawer',
        '#AOV-CartDrawer',
        '.aov-cart-drawer',
        '.AOV-CartDrawer__Container',
        '.cart-drawer',
        '#CartDrawer',
        'cart-drawer',
        '.drawer--cart',
      ];
      let drawer = null;
      for (const selector of selectors) {
        drawer = document.querySelector(selector);
        if (drawer) break;
      }
      if (!drawer) return false;

      if (drawer.hasAttribute('open')) return true;
      const ariaHidden = drawer.getAttribute('aria-hidden');
      if (ariaHidden === 'false') return true;
      const cls = drawer.className || '';
      if (/is-open|open|active|visible/i.test(cls)) return true;
      return false;
    };

    const isMainButtonVisible = () => {
      const mainBtn = findMainButton();
      if (!mainBtn) return false;
      const rect = mainBtn.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight || 0;
      const vw = window.innerWidth || document.documentElement.clientWidth || 0;
      return rect.bottom > 0 && rect.top < vh && rect.right > 0 && rect.left < vw;
    };

    let wantActive = false;

    const setActive = (active) => {
      if (bar._stickyActive === active) return;
      bar._stickyActive = active;
      document.documentElement.classList.toggle('lby-sticky-atc-on', active);
      document.body.classList.toggle('lby-sticky-atc-on', active);
      bar.setAttribute('aria-hidden', active ? 'false' : 'true');
      bar.classList.toggle('is-active', active);

      if (bar._stickyAnim) {
        bar._stickyAnim.cancel();
      }
      const from = active
        ? { transform: 'translateY(110%)', opacity: 0 }
        : { transform: 'translateY(0)', opacity: 1 };
      const to = active
        ? { transform: 'translateY(0)', opacity: 1 }
        : { transform: 'translateY(110%)', opacity: 0 };
      bar._stickyAnim = bar.animate([from, to], {
        duration: 220,
        easing: 'ease',
        fill: 'forwards',
      });
    };

    const updateVisibility = () => {
      const drawerOpen = isDrawerOpen();
      const mainVisible = isMainButtonVisible();
      const nextActive = drawerOpen || mainVisible ? false : wantActive;
      setActive(nextActive);
    };

    const mountObserver = () => {
      const target = findObserveTarget();
      if (!target) return null;

      const io = new IntersectionObserver(() => {
        const rect = target.getBoundingClientRect();
        // Landing behavior: sticky is active only after the top of product sheet is passed.
        wantActive = rect.top <= 0;
        updateVisibility();
      }, { threshold: 0.01 });

      io.observe(target);
      const initialRect = target.getBoundingClientRect();
      wantActive = initialRect.top <= 0;
      updateVisibility();
      return io;
    };

    stickyBtn.addEventListener('click', () => {
      const mainBtn = findMainButton();
      if (mainBtn) mainBtn.click();
    });

    syncState();

    const mo = new MutationObserver(() => syncState());
    mo.observe(form, { subtree: true, childList: true, attributes: true });

    let io = mountObserver();
    window.addEventListener('resize', () => {
      if (io && io.disconnect) io.disconnect();
      io = mountObserver();
    }, { passive: true });
    window.addEventListener('scroll', () => {
      const target = findObserveTarget();
      if (target) {
        const rect = target.getBoundingClientRect();
        wantActive = rect.top <= 0;
      }
      updateVisibility();
    }, { passive: true });

    const observeDrawerChanges = () => {
      const targets = [document.body, document.documentElement];
      targets.forEach((el) => {
        if (!el) return;
        const obs = new MutationObserver(updateVisibility);
        obs.observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
      });

      const drawerSelector = [
        '.AOV-CartDrawer',
        '#AOV-CartDrawer',
        '.aov-cart-drawer',
        '.AOV-CartDrawer__Container',
        '.cart-drawer',
        '#CartDrawer',
        'cart-drawer',
        '.drawer--cart',
      ].join(',');
      const drawerObserver = new MutationObserver(updateVisibility);
      drawerObserver.observe(document.body, { childList: true, subtree: true });

      const initialDrawer = document.querySelector(drawerSelector);
      if (initialDrawer) {
        const obs = new MutationObserver(updateVisibility);
        obs.observe(initialDrawer, { attributes: true, attributeFilter: ['class', 'style', 'open', 'aria-hidden', 'hidden'] });
      }
    };

    updateVisibility();
    observeDrawerChanges();
  }


  packSelector.addEventListener('change', (event) => {
    const target = event.target;
    if (!target || target.type !== 'radio') return;

    packSelector.querySelectorAll('.lby-pack-option').forEach((option) => {
      option.classList.remove('is-selected');
    });

    const selectedOption = target.closest('.lby-pack-option');
    if (selectedOption) selectedOption.classList.add('is-selected');
    if (quantityInput) quantityInput.value = target.value === 'duo' ? '2' : '1';
    const priceBlock = document.getElementById('lally-price');
    if (priceBlock) priceBlock.classList.toggle('is-duo', target.value === 'duo');
  });
  if (quantityInput) quantityInput.value = '1';
  const priceBlock = document.getElementById('lally-price');
  if (priceBlock) priceBlock.classList.remove('is-duo');

  document.querySelectorAll('[data-atc-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error('ATC failed');

        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();

        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
          window.Shopify.onItemAdded(cartData);
        }

        if (window.PubSub && typeof window.PubSub.publish === 'function') {
          window.PubSub.publish('cart:refresh', { cart: cartData });
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
      } catch (error) {
        form.removeAttribute('data-atc-form');
        form.submit();
      }
    });
  });

  document.querySelectorAll('[data-atc-trigger="true"]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      const form = document.querySelector('[data-atc-form]');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.click();
      }
    });
  });

  const hydrateLazyVideo = (video) => {
    if (!video || video.dataset.lazyVideoLoaded === '1') return;
    const sources = Array.from(video.querySelectorAll('source[data-src]'));
    sources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.lazyVideoLoaded = '1';
    if (sources.length) video.load();
  };

  const autoplayVideos = Array.from(document.querySelectorAll('video[data-lby-autoplay-mobile]'));
  if (autoplayVideos.length) {
    const tryPlayMuted = (video) => {
      if (!video) return;
      hydrateLazyVideo(video);
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            tryPlayMuted(entry.target);
          }
        });
      },
      { rootMargin: '500px 0px', threshold: 0.01 }
    );

    autoplayVideos.forEach((video) => {
      if (!video.hasAttribute('autoplay')) video.setAttribute('autoplay', '');
      if (!video.hasAttribute('loop')) video.setAttribute('loop', '');
      video.addEventListener('loadedmetadata', () => tryPlayMuted(video));
      video.addEventListener('canplay', () => tryPlayMuted(video));
      io.observe(video);
    });

    const unlockAutoplay = () => {
      autoplayVideos.forEach((video) => {
        const rect = video.getBoundingClientRect();
        if (rect.top < window.innerHeight + 500 && rect.bottom > -500) {
          tryPlayMuted(video);
        }
      });
      document.removeEventListener('touchstart', unlockAutoplay, true);
      document.removeEventListener('click', unlockAutoplay, true);
    };
    document.addEventListener('touchstart', unlockAutoplay, { passive: true, capture: true, once: true });
    document.addEventListener('click', unlockAutoplay, { capture: true, once: true });
  }

  document.querySelectorAll('video[data-offset]').forEach((video) => {
    const applyOffset = () => {
      const offset = parseFloat(video.dataset.offset || '0');
      if (!Number.isNaN(offset) && offset > 0) {
        try {
          video.currentTime = offset;
        } catch {}
      }
    };

    const applyOffsetIfNeeded = () => {
      const offset = parseFloat(video.dataset.offset || '0');
      if (!Number.isNaN(offset) && offset > 0 && video.currentTime < offset) {
        applyOffset();
        const tryPlay = () => {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        };
        if (video.readyState >= 2) {
          tryPlay();
        } else {
          video.addEventListener('canplay', tryPlay, { once: true });
        }
      }
    };

    const enforceOffsetOnPlayback = () => {
      const offset = parseFloat(video.dataset.offset || '0');
      if (Number.isNaN(offset) || offset <= 0) return;
      let applied = false;
      const onTimeUpdate = () => {
        if (applied) return;
        if (video.currentTime < offset - 0.05) {
          try {
            video.currentTime = offset;
          } catch {}
        } else {
          applied = true;
          video.removeEventListener('timeupdate', onTimeUpdate);
        }
      };
      video.addEventListener('timeupdate', onTimeUpdate);
    };

    if (video.readyState >= 2) {
      applyOffsetIfNeeded();
    }

    video.addEventListener('loadedmetadata', applyOffsetIfNeeded, { once: true });
    video.addEventListener('canplay', applyOffsetIfNeeded, { once: true });
    video.addEventListener('play', applyOffsetIfNeeded, { once: true });
    video.addEventListener('playing', applyOffsetIfNeeded, { once: true });
    enforceOffsetOnPlayback();
  });
})();

(() => {
  const track = document.querySelector('[data-pp-why-track], [data-lby-why-track]');
  const dotsWrap = document.querySelector('[data-pp-why-dots], [data-lby-why-dots]');
  if (!track || !dotsWrap) return;

  const cards = Array.from(track.querySelectorAll('.pp-why__card, .lby-why-modern__card'));
  if (cards.length <= 1) return;

  const isMobile = () => window.matchMedia('(max-width: 980px)').matches;

  const gapPx = () => {
    const cs = getComputedStyle(track);
    const g = parseFloat(cs.gap || cs.columnGap || 14);
    return Number.isFinite(g) ? g : 14;
  };

  const step = () => {
    if (!cards[0]) return 0;
    return cards[0].getBoundingClientRect().width + gapPx();
  };

  let dragSession = false;
  let dragStartScroll = 0;
  let dragStartIndex = 0;

  const currentIndex = () => {
    const s = step() || 1;
    return Math.round(track.scrollLeft / s);
  };

  const updateDots = (active) => {
    Array.from(dotsWrap.children).forEach((d, i) => {
      d.classList.toggle('is-active', i === active);
    });
  };

  const buildDots = () => {
    dotsWrap.innerHTML = '';
    cards.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Aller à la carte ${i + 1}`);
      b.addEventListener('click', () => {
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
        updateDots(i);
      });
      dotsWrap.appendChild(b);
    });
    updateDots(0);
  };

  let ticking = false;
  const onScroll = () => {
    if (!isMobile()) return;
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateDots(Math.max(0, Math.min(cards.length - 1, currentIndex())));
      ticking = false;
    });
  };

  const nearestIndex = () => {
    const s = step() || 1;
    return Math.round(track.scrollLeft / s);
  };

  const onDragStart = () => {
    if (!isMobile()) return;
    dragSession = true;
    dragStartScroll = track.scrollLeft;
    dragStartIndex = currentIndex();
  };

  const onDragEnd = () => {
    if (!isMobile() || !dragSession) return;
    const delta = track.scrollLeft - dragStartScroll;
    const s = step() || 1;
    if (Math.abs(delta) < (s * 0.5) && Math.abs(delta) > 0) {
      track.scrollTo({ left: (dragStartIndex + (delta > 0 ? 1 : -1)) * s, behavior: 'smooth' });
    } else {
      track.scrollTo({ left: nearestIndex() * s, behavior: 'smooth' });
    }
    dragSession = false;
  };

  buildDots();
  if (isMobile()) {
    track.scrollTo({ left: 0, behavior: 'auto' });
    updateDots(0);
  }
  track.addEventListener('scroll', onScroll, { passive: true });
  track.addEventListener('pointerdown', onDragStart, { passive: true });
  track.addEventListener('pointerup', onDragEnd, { passive: true });
  track.addEventListener('pointercancel', onDragEnd, { passive: true });
  track.addEventListener('touchstart', onDragStart, { passive: true });
  track.addEventListener('touchend', onDragEnd, { passive: true });

  window.addEventListener('resize', () => {
    if (isMobile()) {
      if (!dotsWrap.children.length) buildDots();
      updateDots(currentIndex());
    } else {
      dotsWrap.innerHTML = '';
    }
  });
})();

(() => {
  const faqs = Array.from(document.querySelectorAll('.lp-faq, .pp-faq, #faq'));
  if (!faqs.length) return;

  const itemSelector = '.lp-faq__item, .pp-faq__item, .faq-item';
  const btnSelector = '.lp-faq__btn, .pp-faq__btn, .faq-question';
  const answerSelector = '.lp-faq__answer, .pp-faq__answer, .faq-answer';

  const setItemState = (item, isOpen) => {
    const btn = item.querySelector(btnSelector);
    const answer = item.querySelector(answerSelector);
    if (!btn || !answer) return;
    item.classList.toggle('is-open', isOpen);
    item.classList.toggle('active', isOpen);
    answer.style.maxHeight = isOpen ? `${answer.scrollHeight}px` : null;
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  };

  faqs.forEach((faq) => {
    const faqItems = Array.from(faq.querySelectorAll(itemSelector));
    faqItems.forEach((item) => {
      const btn = item.querySelector(btnSelector);
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open') || item.classList.contains('active');
        faqItems.forEach((otherItem) => {
          if (otherItem !== item) setItemState(otherItem, false);
        });
        setItemState(item, !isOpen);
      });
    });
  });
})();

(() => {
  const footer = document.querySelector('footer.footer');
  if (!footer) return;

  const setFooterHeight = () => {
    const radiusL = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--radius-l')) * 16;
    const h = Math.max(0, Math.min(footer.getBoundingClientRect().height, Math.round(window.innerHeight * 0.75)) - radiusL) || 0;
    document.documentElement.style.setProperty('--footer-reveal-height', `${h}px`);
    // Force MainContent à descendre jusqu'au bas du viewport pour que margin-bottom = h de scroll exact
    const main = document.getElementById('MainContent');
    if (main) {
      main.style.minHeight = '';
      const needed = window.innerHeight - main.offsetTop - main.offsetHeight;
      if (needed > 0) main.style.minHeight = `${main.offsetHeight + needed}px`;
    }
  };

  setFooterHeight();
  window.addEventListener('resize', setFooterHeight);
})();

(() => {
  const track = document.querySelector('[data-pp-sol-track], [data-solution-track]');
  const dotsWrap = document.querySelector('[data-pp-sol-dots], [data-solution-dots]');
  if (!track || !dotsWrap) return;

  const cards = Array.from(track.querySelectorAll('.pp-sol__card, .solution-block'));
  if (cards.length <= 1) return;

  const isMobile = () => window.matchMedia('(max-width: 980px)').matches;

  const gapPx = () => {
    const cs = getComputedStyle(track);
    const g = parseFloat(cs.gap || cs.columnGap || 14);
    return Number.isFinite(g) ? g : 14;
  };

  const step = () => {
    if (!cards[0]) return 0;
    return cards[0].getBoundingClientRect().width + gapPx();
  };

  const updateDots = (active) => {
    Array.from(dotsWrap.children).forEach((d, i) => {
      d.classList.toggle('is-active', i === active);
    });
  };

  let dragSession = false;
  let dragStartScroll = 0;
  let dragStartIndex = 0;

  const currentIndex = () => {
    const s = step() || 1;
    return Math.round(track.scrollLeft / s);
  };

  const buildDots = () => {
    dotsWrap.innerHTML = '';
    cards.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Aller à la carte ${i + 1}`);
      b.addEventListener('click', () => {
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
        updateDots(i);
      });
      dotsWrap.appendChild(b);
    });
    updateDots(0);
  };

  let ticking = false;
  const onScroll = () => {
    if (!isMobile()) return;
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateDots(Math.max(0, Math.min(cards.length - 1, currentIndex())));
      ticking = false;
    });
  };

  const onDragStart = () => {
    if (!isMobile()) return;
    dragSession = true;
    dragStartScroll = track.scrollLeft;
    dragStartIndex = currentIndex();
  };

  const nearestIndex = () => {
    const s = step() || 1;
    return Math.round(track.scrollLeft / s);
  };

  const onDragEnd = () => {
    if (!isMobile() || !dragSession) return;
    const delta = track.scrollLeft - dragStartScroll;
    const s = step() || 1;
    if (Math.abs(delta) < (s * 0.5) && Math.abs(delta) > 0) {
      track.scrollTo({ left: (dragStartIndex + (delta > 0 ? 1 : -1)) * s, behavior: 'smooth' });
    } else {
      track.scrollTo({ left: nearestIndex() * s, behavior: 'smooth' });
    }
    dragSession = false;
  };

  buildDots();
  if (isMobile()) {
    requestAnimationFrame(() => {
      track.scrollTo({ left: 0, behavior: 'auto' });
      updateDots(0);
    });
  }
  track.addEventListener('scroll', onScroll, { passive: true });
  track.addEventListener('pointerdown', onDragStart, { passive: true });
  track.addEventListener('pointerup', onDragEnd, { passive: true });
  track.addEventListener('pointercancel', onDragEnd, { passive: true });
  track.addEventListener('touchstart', onDragStart, { passive: true });
  track.addEventListener('touchend', onDragEnd, { passive: true });

  window.addEventListener('resize', () => {
    if (isMobile()) {
      if (!dotsWrap.children.length) buildDots();
      updateDots(currentIndex());
    } else {
      dotsWrap.innerHTML = '';
    }
  });
})();


(() => { document.addEventListener("DOMContentLoaded", () => {
  const textBlocks = document.querySelectorAll(".lp-flow__text, .lby-text-block");
  const visuals = document.querySelectorAll(".lp-flow__visual, .lby-visual-item");
  
// On détecte si c'est un mobile (écran < 768px)
  const isMobile = window.innerWidth < 768;

  const options = {
    root: null,
    // SUR MOBILE : On décale la zone de détection vers le bas (-60% en haut)
    // SUR DESKTOP : On garde la ligne du milieu (-45%)
    rootMargin: isMobile ? "-40% 0px -50% 0px" : "-45% 0px -45% 0px",
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 1. Activer le bloc texte
        textBlocks.forEach(el => el.classList.remove("is-active"));
        entry.target.classList.add("is-active");

        // 2. Changer l'image correspondante
        const index = entry.target.dataset.step;
        visuals.forEach((visual) => {
          visual.classList.remove("is-active");
          if (visual.dataset.index === index) {
            visual.classList.add("is-active");
          }
        });
      }
    });
  }, options);

  textBlocks.forEach((block) => {
    observer.observe(block);
  });
});

})();
